import React from "react";

/**
 * The spinner for work the user just started — submitting a form, exporting a
 * file, saving a dialog.
 *
 * Deliberately NOT a skeleton: a skeleton reserves space for content that is
 * on its way, and here the button is already on screen and does not change
 * size. Swapping its label for grey bars would be a regression.
 *
 * `currentColor` so it inherits the button's text colour instead of each call
 * site picking its own blue — this replaces four near-identical hand-rolled
 * spinners.
 */
export default function InlineSpinner({ className = "h-4 w-4", label }) {
  return (
    <svg
      className={`animate-spin motion-reduce:animate-none ${className}`}
      viewBox="0 0 24 24"
      fill="none"
      role={label ? "status" : "presentation"}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : "true"}
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}

/**
 * Full-height centred spinner for the auth gates — the moment before the app
 * knows which route it is even rendering, so there is no content shape to
 * stand in for yet.
 */
export function FullPageSpinner({ label }) {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <InlineSpinner className="h-10 w-10 text-primary" label={label} />
    </div>
  );
}
